/* eslint-disable no-restricted-imports */
import { Box, Grid } from '@material-ui/core';

import { Skeleton } from '@mui/material';

export default function FilterSkeleton() {
  return (
    <Box marginTop={2}>
      <Skeleton
        variant='rectangular'
        width='100%'
        height={40}
        style={{ borderRadius: 8, marginBottom: 16 }}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Skeleton variant='rectangular' width='100%' height={40} style={{ borderRadius: 4 }} />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Skeleton variant='rectangular' width='100%' height={40} style={{ borderRadius: 4 }} />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Skeleton variant='rectangular' width='100%' height={40} style={{ borderRadius: 4 }} />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Skeleton variant='rectangular' width='100%' height={40} style={{ borderRadius: 4 }} />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Skeleton variant='rectangular' width='100%' height={40} style={{ borderRadius: 4 }} />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={2}>
          <Skeleton variant='rectangular' width='100%' height={40} style={{ borderRadius: 4 }} />
        </Grid>
      </Grid>

      <Box marginTop={3} paddingTop={2} borderTop='1px solid #e0e0e0'>
        <Skeleton variant='text' width={200} height={20} />
        <Skeleton variant='text' width={150} height={16} style={{ marginTop: 4 }} />
      </Box>
    </Box>
  );
}
